import getStore from '../data/store';
import { mutatorAction } from 'satcheljs';
import { PlaceModel } from 'owa-location-service';
import CardViewState from 'owa-location-card-v2/lib/data/schema/CardViewState';

export const setPlace = mutatorAction('setPlace', (place: PlaceModel) => {
    getStore().place = place;
});

export const setViewState = mutatorAction('setViewState', (viewState: CardViewState) => {
    getStore().viewState = viewState;
});

export const setIsLoading = mutatorAction('setIsLoading', (isLoading: boolean) => {
    getStore().viewState.isLoading = isLoading;
});

export const setIsDataLoaded = mutatorAction('setIsDataLoaded', (isDataLoaded: boolean) => {
    getStore().viewState.isDataLoaded = isDataLoaded;
});
